import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoBoundaryModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoBoundaryModel._instance == null) GeoBoundaryModel._instance = new GeoBoundaryModel(authManager);
        return GeoBoundaryModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-boundaries');

        this.entityName = 'model-sections.GeoBoundary';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Section Boundary';
        this.setLabel = 'Section Boundaries';

        this.browser = {
            name: 'default-model-sections-geoboundary-browser',
            moduleName: 'default-model-sections-geoboundary-browser',
            moduleTitle: 'Section Boundaries',
            moduleStateSlotName: 'default-model-sections-geoboundary-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoboundary-editor',
            moduleName: 'default-model-sections-geoboundary-editor',
            moduleTitle: 'Section Boundary',
            moduleStateSlotName: 'default-model-sections-geoboundary-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'boundaryTypeId',
                type: 'GeoBoundaryType',
                persistent: true,
                label: 'Boundary Type',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'elevation',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: true,
                label: 'Model Section',
                description: 'only for info (check)',
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
